module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/textBlockRight.39db4dfd.svg";